/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
/* eslint-disable react/prop-types */
import React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
// import * as Colors from '@mui/material/colors';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/esm/DeleteForever';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography/Typography';
import * as Actions from '../../actions/actions';
import DateTimeHelper from '../../helper/DateTimeHelper';

const sortNotifications = (a,b) => new Date(b.timestamp) - new Date(a.timestamp);


class NotificationsDrawer extends React.Component {

	handleClear = () => {
		this.props.clearNotifications();
		this.props.close()
	};

	render() {
		const { notifications } = this.props.notifications;
		return (
            <Drawer
				anchor="right"
				open={this.props.anchorEl !== null}
				onClose={() => this.props.close()}
			>
				<div
					style={{
						width: '100%',
						height: '48px',
						backgroundColor: 'grey',
						display: 'flex',
						justifyContent: 'space-between',
					}}
				>
					<Typography
						variant="h6"
						style={{
							color: 'white',
							padding: '10px 15px',
						}}
					>
						<FormattedMessage id="Notification.list.subheader" defaultMessage="Notifications" />
					</Typography>
					{ notifications.length < 1 ? null : (
						<IconButton
                            aria-label="Clean"
                            onClick={this.handleClear}
                            style={{
								float: 'right',
								color: 'white',
							}}
                            size="large">
							<ClearIcon />
						</IconButton>
					) }
				</div>
				<div>
					<List>
						{ notifications.sort(sortNotifications).map(notification => [
							<ListItem divider>
								<ListItemText
									primary={notification.title || 'System'}
									secondary={
										<React.Fragment>
											<div style={{ maxWidth: '250px' }}>
												<span style={{ maxWidth: '250px'  }}>
													{DateTimeHelper.formatTimestamp(notification.timestamp)}
												</span> --
												{notification.message}
											</div>
											<div style={{ maxWidth: '250px' }}>
												{notification.reference}
											</div>
										</React.Fragment>
									}
								/>
							</ListItem>,
							<Divider variant="inset" />,
						]) }

					</List>
				</div>
			</Drawer>
        );
	}
}


function mapStateToProps(state) {
	return {
		notifications: state.notifications,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ ...Actions }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(NotificationsDrawer));
